import React from "react";
import Label from './LabelUtilsComponet'
import Required from './RequiredComponent'

class Calendar extends React.Component {
  handlerChange = date => {
    this.props.onChange(this.props.config.variable, date.target.value);
  };

  render() {
    const { config } = this.props;
    return (
      <div className={config.classContainer}>
        <Label {...config} />
        <div className="div-input-form">
          <input
            type='date'
            className={config.classInput}
            min={config.minDate}
            max={config.maxDate}
            onChange={this.handlerChange}
            placeholder={config.placeholder}
            value={config.value}
          />
        </div>
        {
          <Required {...config} msg="Seleccione una fecha" />
        }
      </div>
    );
  }
}
export default Calendar;
